export const categoryList = (r) => require.ensure([], () => r(require("./categoryList/categoryList.vue")), "categoryList");
